export default function Footer() {
    return (
      <div style={{textAlign:'center'}}>
          <hr />
          <br />
          <span className={"text-gray-500"}>&copy; {new Date().getFullYear()} - Regions Financial Services - All rights reserved. V-{window.getConfig(`CUSTOMER_PORTAL_APP_VERSION`) || '1.0.0'}</span>
          <br /><br />
      </div>
    );
  }